import { Grid, Stack } from "@mui/material";
import { Label } from "./SelectAccountType";
import { Field, useFormikContext } from "formik";
import { StyledTextField } from "./styled-components/AddressFields";
import { StyledEndAdorment } from "./AddressLookup";
import { FormValues } from "./utils/formSchema";
import { useAppDispatch } from "src/store/store";
import { useEffect } from "react";
import { batch } from "react-redux";
import { setFirstName, setLastName, setOccupation } from "src/store/features/onboarding.slice";

export function ReKycAboutYouDetails() {
  const dispatch = useAppDispatch();
  const {
    values: { firstname, lastname, occupation },
    errors: { firstname: firstNameError, lastname: lastNameError, occupation: occupationError },
  } = useFormikContext<FormValues>();

  useEffect(() => {
    // Update context so data is available when navigated back & forth
    // This will result in a single re-render, no matter how many actions are dispatched within the batch function.
    batch(() => {
      dispatch(setFirstName(firstname));
      dispatch(setLastName(lastname));
      dispatch(setOccupation(occupation));
    });
  }, [firstname, lastname, occupation]);

  return (
    <>
      <Grid item xs={12} sm={6} mb={1}>
        <Stack spacing={1}>
          <Label text="First Name" />
          <Field
            name="firstname"
            as={StyledTextField}
            selected={!!firstname}
            InputProps={{
              endAdornment: <StyledEndAdorment selected={!!firstname} />,
            }}
            error={!!firstNameError}
            helperText={firstNameError}
          />
        </Stack>
      </Grid>
      <Grid item xs={12} sm={6} mb={1}>
        <Stack spacing={1}>
          <Label text="Last Name" />
          <Field
            name="lastname"
            as={StyledTextField}
            selected={!!lastname}
            InputProps={{
              endAdornment: <StyledEndAdorment selected={!!lastname} />,
            }}
            error={!!lastNameError}
            helperText={lastNameError}
          />
        </Stack>
      </Grid>
      <Grid item xs={12} sm={6} mb={1}>
        <Stack spacing={1}>
          <Label text="What is your occupation?" />
          <Field
            name="occupation"
            as={StyledTextField}
            selected={!!occupation}
            InputProps={{
              endAdornment: <StyledEndAdorment selected={!!occupation} />,
            }}
            error={!!occupationError}
            helperText={occupationError}
          />
        </Stack>
      </Grid>
    </>
  );
}
